import { render, staticRenderFns } from "./SecureUpload.vue?vue&type=template&id=152f37b8"
import script from "./SecureUpload.vue?vue&type=script&lang=js"
export * from "./SecureUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports